<template>
    <div ref="snackbarContainer" :class="containerClass">
        <transition-group ref="transition" name="ur-snackbar__slide" tag="div">
            <div v-for="snackbar in snackbarList" :key="snackbar.idx" class="ur-snackbar">
                <div class="ur-snackbar__content">
                    <!--$ver: v2.1.0
                    Snackbar의 내용이 들어가는 영역입니다.
                    #This is the area that contains the contents of the Snackbar.-->
                    <slot>{{snackbar.text}}</slot>
                </div>

                <div class="ur-snackbar__action">
                    <!--$ver: v2.1.0
                    Snackbar의 우측에 간단한 action(icon, button) 등을 넣을 수 있는 영역입니다.
                    #This area is where you can put simple actions (icon, button) on the right side of the Snackbar.-->
                    <slot name="action">
                        <ur-button v-if="closeBtn" borderless primary @click="clickCloseBtn(snackbar)">
                            Close <!--다국어-->
                        </ur-button>
                    </slot>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
    import snackbarEvent from "./snackbarEvents";
    export default {
        name: "urSnackbar",
        props: {
            // $ver: v0.2.1
            // 중첩 가능 여부입니다. (slot을 사용할 경우 중첩 불가능으로 무시됩니다.)
            // #Whether it can be nested. (If using slot, it is ignored as non-stackable.)
            // $default: false
            stackable: {type:Boolean, default:false},
            // $ver: v0.2.1
            // snackbar 의 표시 유지 시간입니다. (show 메소드에 매개변수가 전달될 경우 무시됩니다.)
            // #Time to keep the snackbar visible. (If a parameter is passed to the show method, it is ignored.)
            // #it is returned as an Array of length 2 whose value is the element.
            // $default: 2000
            duration: {type:Number, default:2000},
            // $ver: v0.2.1
            // 닫힘 버튼 유무입니다. (show 메소드에 매개변수가 전달될 경우 무시됩니다.)
            // #Is there a closed button. (If a parameter is passed to the show method, it is ignored.)
            // $default: false
            closeBtn: {type:Boolean, default:false},
        },
        data() {
          return {
              snackbarList : [],
              snackbarIdx: 0,
              isHiding: false,
              isAdding: true,
          }
        },
        computed: {
            cDuration() {
                let rtn = this.duration * 1;
                return isNaN(rtn)? 2000 : rtn;
            },
            cStackable() {
                return this.stackable && !this.$slots['default'];
            },
            containerClass() {
                const rtn = [];
                rtn.push('ur-snackbar__container');
                //나중에 위치 추가
                rtn.push('ur-snackbar__container-bottom');
                rtn.push('ur-snackbar__container-center');
                // 추가중의 move인지 제거 중의 move인지 css가 구분할 수 있게 하기 위한 빈 클래스
                // 제거중의 move일 경우 제거되는 아이템이 사라질때 가지 기다렸다가 move가 시작될 수 있도록 시간 지연 입력
                if(this.isAdding) {
                    rtn.push('ur-snackbar__container-add');
                } else {
                    rtn.push('ur-snackbar__container-remove');
                }
                // width : auto를 보장하기 위한 장치
                // 없을 경우 마지막 아이템이 사라질 때 width가 측정되지 않아서 크기가 짜부러진 채로 사라지게 됨
                if(this.snackbarList.length > 0){
                    rtn.push('ur-snackbar__more-than-one-item');
                }
                return rtn;
            },
        },
        mounted() {
            this.appendCon();
        },
        beforeDestroy() {
            this.removeCon();
        },
        methods: {
            // @vuese
            // $ver: v0.2.1
            // $return: N/A
            // Snackbar를 표시합니다. ref를 통하여 호출합니다.
            // #Displays Snackbar. Called through ref.
            show(params) {
                let snackbar = {};
                if(params) {
                    snackbar = JSON.parse(JSON.stringify(params));
                }
                if(this.cStackable) {
                    this.isAdding = true;
                    const idx = this.snackbarIdx++;
                    snackbar.idx = idx;
                    this.snackbarList.push(snackbar);
                    setTimeout(() => {
                        this.close(snackbar);
                    }, this.cDuration)
                } else {
                    if(this.snackbarList.length > 0 || this.isHiding){
                        return;
                    }
                    const idx = this.snackbarIdx++;
                    snackbar.idx = idx;
                    this.snackbarList.push(snackbar);
                    setTimeout(() => {
                        this.close(snackbar);
                        this.isHiding = true;

                    }, this.cDuration)
                }
            },
            // @vuese
            // $ver: v0.2.1
            // $return: N/A
            // Snackbar를 닫습니다. ref를 통하여 호출합니다.
            // #Close the Snackbar. Called through ref.
            close(snackbar){
                // $ver: v0.2.1
                // $arg: snackbar
                // snackbar가 닫힐 때의 시점을 제공합니다.
                // #Provides a event in time when the Snackbar is closed.
                this.$emit('closed', snackbar);

                this.isAdding = false;
                let idx = this.snackbarList.indexOf(snackbar);
                if (idx > -1 ) {
                    this.snackbarList.splice(this.snackbarList.indexOf(snackbar), 1);
                }
                setTimeout(() => {
                    this.isHiding = false;
                }, 500)
            },
            clickCloseBtn(snackbar) {
                this.close(snackbar);
            },
            appendCon() {
                let me = this;
                this.$nextTick(function() {
                    let con = me.$refs.snackbarContainer;
                    if(!con) {
                        console.warn("[UR-MODAL] Detect hot reloaded, Please refresh browser.");
                        return;
                    }//
                    // con.setAttribute("key",me.tempKey);
                    // let root = document.getElementById(me.rootId);
                    let root = me.$root.$el;
                    root.appendChild(con);
                });
            },
            removeCon() {
                let el = this.$refs.snackbarContainer;
                if(el && el.parentNode) {
                    el.parentNode.removeChild(el);
                }
            },
            beforeLeave(el) {
                el.style.transitionDelay = '1000ms'
            },
            afterLeave(el) {
                el.style.transitionDelay = ''
            },
        }
    }
</script>